import { useNavigate, useParams } from "react-router-dom";
import { Shuffle } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";

export const WanderButton = ({ className = "", label = "Wander", testid = "wander-codex-button" }) => {
  const navigate = useNavigate();
  const { slug } = useParams();
  const go = async () => {
    try {
      const { data } = await api.get("/articles/random", { params: { exclude: slug } });
      navigate(`/wiki/${data.slug}`);
    } catch {
      toast.error("The codex is still empty");
    }
  };
  return (
    <button type="button" onClick={go} data-testid={testid} title="Wander the Codex — open a surprise page" className={className}>
      <Shuffle className="w-4 h-4" /> {label}
    </button>
  );
};
